import React, { useCallback, useEffect, useState } from 'react';
import { Upload } from 'lucide-react';
import { useAuth } from '../AuthContext';
import { uploadRequestsApi } from '../uploadRequestsApi';
import { RequestActions, RequestRow } from '../UploadRequestsCard';

// Ticket 211 (211-4): upload links this user sent that a borrower can still
// open, so they can be turned off or swapped. Hidden when there are none.
export function OpenUploadLinks() {
  const user = useAuth()?.user;
  const perms = user?.permissions || [];
  const canSee = !!user && (user.is_super_admin || perms.includes('documents.view'));
  const canIssue = !!user && (user.is_super_admin || perms.includes('links.issue'));
  const [items, setItems] = useState([]);

  const load = useCallback(() => {
    if (!canSee) return;
    uploadRequestsApi.list({ mine: true, outstanding: true })
      .then(setItems)
      .catch(() => setItems([]));
  }, [canSee]);

  useEffect(() => { load(); }, [load]);

  if (!canSee || items.length === 0) return null;
  return (
    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5" data-testid="open-upload-links">
      <div className="flex items-center gap-2 mb-3 text-sm font-medium text-slate-500">
        <Upload size={14} /> Upload links still open ({items.length})
      </div>
      <ul className="divide-y divide-slate-100">
        {items.map((r) => (
          <RequestRow key={r.request_id} req={r} showContact onChanged={load}>
            {canIssue && <RequestActions req={r} onChanged={load} />}
          </RequestRow>
        ))}
      </ul>
    </div>
  );
}
